import React from 'react';
import css from './timeline.module.scss';

export function Timeline({ children }) {
  return (
    <div className={css.timeline}>
      { children }
    </div>
  );
}

Timeline.Item = function Item({ date, children }) {
  return (
    <div className={css.item}>
      <div className={css.date}>{ date }</div>
      { children }
    </div>
  );
}
